import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import DaEditorWrapper from '@wix/da-shared-react/pkg/DaEditorWrapper/LoadableDaEditorWrapper';
import { EditorFlavourConfigs } from '@wix/da-shared-react/pkg/DaEditorWrapper/config';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import { useEditor } from '@wix/da-shared-react/pkg/DaEditorWrapper/hooks';
import { EditorWrapperState } from '@wix/da-shared-react/pkg/DaEditorWrapper/types';
import mergeTheme from '@wix/da-shared-react/pkg/DaEditorWrapper/Themes/mergeTheme';
import { DESCRIPTION_MAX_LENGTH } from './constants';
import { EditorAPI } from '@wix/da-shared-react/pkg/DaEditor/types';

import textTheme from '@wix/da-shared-react/src/DaEditorWrapper/Themes/Viewer/donation.scss';
import editorTheme from '@wix/da-shared-react/src/DaEditorWrapper/Themes/Editor/donation.scss';
import s from './DonationsConfigModal.scss';

// Merge the text theme with the editor theme (content vs editor toolbars etc)
const donationTheme = mergeTheme(textTheme, editorTheme);

interface Props {
  initialContent?: any;
  onEditorChange?: (editorState: EditorWrapperState) => void;
  onEditorReady?: (editorApi: EditorAPI) => void;
}

const DonationEditor: React.FC<Props> = ({
  initialContent,
  onEditorChange,
  onEditorReady,
}) => {
  const { t } = useTranslation();
  const { editorToolbars, editorProps, editorApi } = useEditor({
    onEditorChange: editorState => {
      onEditorChange && onEditorChange(editorState);
    },
  });
  onEditorReady && editorApi && onEditorReady(editorApi);

  const FooterToolbar = editorToolbars?.INSERT_PLUGIN;

  return (
    <>
      <InputLabelText className={s['description-label']}>
        {t!('widgets.donations.form.description')}
      </InputLabelText>
      <div className={editorTheme['editor-wrapper']}>
        <DaEditorWrapper
          loadingComponent={LoadingIndicator}
          flavour={EditorFlavourConfigs.DONATION}
          theme={donationTheme}
          initialContent={initialContent}
          filterPaste={true}
          charLimit={DESCRIPTION_MAX_LENGTH}
          {...editorProps}
        />
      </div>
      {FooterToolbar && (
        <div className={editorTheme['editor-footer']}>
          <div className={s['editor-footer-controls']}>
            <FooterToolbar />
          </div>
        </div>
      )}
    </>
  );
};
DonationEditor.displayName = 'DonationEditor';

export default DonationEditor;
